import React, { Component } from 'react';
import { Mutation } from "react-apollo"
import gql from "graphql-tag"

const prepareMenuItems = (edges) => {
  return edges.map(edge => {
    const node = { ...edge.node }
    if (node.childItems) {
      node.childItems = prepareMenuItems(node.childItems.edges)
    }
    return node
  })

}

export default (location, prop = 'formSubmission', functionProp = 'submitForm') => WrappedComponent => class WithNav extends Component {
  render() {
    return (
      <Mutation
        mutation={gql`
          mutation SubmitFormEntry($formId: String, $data: String) {
            submitFormEntry(formId: $formId, data: $data) {
              errors
            }
          }
        `}
      >
        {(submitForm, { loading, error, data }) => (
          <div>
            {!error &&
              <WrappedComponent
                {...this.props}
                {...{
                  [functionProp]: submitForm,
                  [`${prop}Loading`]: loading,
                  [`${prop}`]: !loading && !error && data && data.submitFormEntry,
                }}
              />
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Mutation>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/withSubmitFormMutation.js